import React from 'react';
import { PageNotFound } from '@base-components';

export default function NotFoundPage(): JSX.Element {
  return <PageNotFound />;
}
